export default __webpack_public_path__ + "images/JM.150ee33.png";